import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import uniqBy from 'lodash/uniqBy';
import unescape from 'unescape';
import Head from 'next/head';
import { withRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';
import dynamic from 'next/dynamic';
import nextI18nextConfig from '~/../next-i18next.config';
import defaultStaticPage, {
  defaultPageStaticContext,
} from '~/../hocs/defaultStaticPage';
import ChinaWrap from '~/components/ChinaWrap';
import MetaTwitter from '~/components/MetaTwitter';
import Config, { keyConfig } from '~/config';
import Layout from '~/containers/Layout';
import {
  makeSelectCurrentLang,
  makeSelectLink,
} from '~/containers/MetadataProvider/selectors';
const PhotoContainer = dynamic(() => import('~/containers/PhotoPage'));
const IllustPage = dynamic(() => import('~/containers/PhotoPage/IllustPage'));
import {
  getCurrentStatusDownloadFromRedis,
  loadPhoto,
  loadRelatedData,
  loadSimilar,
  loadSimilarDesign,
  loadStatitics,
  logClick,
  loadCurrentUserExtraLicense,
  loadCardInfo,
} from '~/containers/PhotoPage/actions';
import Cookies from '~/services/Cookies';
import { loadELPlans } from '~/containers/ExtraLicensePaymentModal/actions';
import { fileHelper, slugs } from '~/utils';
import { throw404 } from '~/utils/redirect';
import { getCanonical } from '~/components/HrefLangs';
import { wrapper } from '~/store';
import { loadPinterest } from '~/utils/file-helper';
import { loadCommentsData } from '~/containers/Comment/actions';

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    router: { query },
    lng,
  } = ownProps;
  return {
    logClick: (params) => dispatch(logClick(params)),
    loadStatistics: () => dispatch(loadStatitics(query.id)),
    loadSimilar: (params) => dispatch(loadSimilar(params)),
    loadRelatedData: () => dispatch(loadRelatedData(query.id)),
    loadSimilarDesign: () => {
      const gotIt = Cookies.get('gotIt');
      return dispatch(loadSimilarDesign(query.id, gotIt, lng));
    },
    loadELPlans: () => dispatch(loadELPlans()),
    loadCurrentStatusDownload: (userId) =>
      dispatch(getCurrentStatusDownloadFromRedis(userId)),
    loadCurrentUserExtraLicense: (params) =>
      dispatch(loadCurrentUserExtraLicense(params)),
    loadCardInfo: () => dispatch(loadCardInfo()),
    loadCommentsData: (params) => dispatch(loadCommentsData(params)),
  };
};
const mapStateToProps = (state) => ({
  photo: state.photo.detail,
  currentLang: makeSelectCurrentLang(),
  link: makeSelectLink(),
});

@withRouter
@defaultStaticPage()
@connect(mapStateToProps, mapDispatchToProps)
class Photo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stripe: null,
      canonical: [],
    };
  }

  async componentDidMount() {
    const {
      loadCurrentStatusDownload,
      logClick,
      profile,
      photo,
      loadRelatedData,
      loadSimilar,
      loadELPlans,
      // loadSimilarDesign,
      isFromServer,
      loadCurrentUserExtraLicense,
      loadCardInfo,
      lng,
    } = this.props;

    loadPinterest();
    if (profile && profile.role == 'premium') {
      loadCurrentStatusDownload(profile.user_id);

      loadCardInfo();
    }
    loadCurrentUserExtraLicense({ id: photo.id });

    if (profile && profile.role != 'premium') {
      this.setState({
        stripe: await fileHelper.loadStripeJS(),
      });
    }

    if (isFromServer) {
      loadELPlans();
      console.log('photophotophoto', photo);
      if (photo?.tags?.length > 0) {
        const keyword = photo.tags[0]['name_ja']
          ? photo.tags[0]['name_ja']
          : photo.tags[0][`name_${lng === 'jp' ? 'ja' : lng}`];
        loadSimilar({ keyword });
      }
      if (!Config.isDesignAC()) {
        loadRelatedData();
      }

      if (profile && profile.user_id && Config.isPhotoAC()) {
        logClick({
          userId: profile.user_id,
          dataId: photo.id,
        });
      }
    }

    // Remove duplicated canonical links
    if (process.browser) {
      const canonicalLinks = [
        ...document.querySelectorAll('link[rel="canonical"]'),
      ];
      canonicalLinks.slice(1).forEach((e) => {
        e.remove();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { loadSimilar, loadRelatedData, photo, lng } = this.props;
    if (photo?.id && photo?.id !== prevProps.photo?.id) {
      console.log('photophotophoto', photo);
      if (photo?.tags?.length > 0) {
        const keyword = photo.tags[0]['name_ja']
          ? photo.tags[0]['name_ja']
          : photo.tags[0][`name_${lng === 'jp' ? 'ja' : lng}`];
        loadSimilar({ keyword });
      }
      if (!Config.isDesignAC()) {
        loadRelatedData();
      }
    }
  }

  getMetaDataParams() {
    const { photo } = this.props;
    const titles = photo.title;
    const { creator } = photo;
    const { tags } = photo;
    const { id = [] } = photo;
    let { lng } = this.props;
    if (lng === 'tw') lng = 'zh-tw';
    if (lng === 'cn') lng = 'zh-cn';

    return {
      title: (lang) => {
        if (titles) {
          return Config.getTitleByLanguage(titles, lang);
        }
        return '';
      },
      titleSlug: (lang) => {
        if (titles) {
          const titleByLang = Config.getTitleByLanguage(titles, lang);
          let slug = slugs.makeSlug(titleByLang, { lang });
          if (!slug || slug == '') {
            return '';
          } else {
            return slug;
          }
        }
        return '';
      },
      creator: () => {
        if (creator) {
          return creator.nickname;
        }
        return '';
      },
      tagsNameTitle: () => {
        if (tags) {
          const tag = uniqBy(
            photo.tags || [],
            `name_${lng === 'jp' ? 'ja' : lng}`,
          );
          return Config.getTagTitleByCharacter(tag, id, ' ', lng);
        }
        return '';
      },
      tagsName: () => {
        if (tags) {
          const tag = uniqBy(
            photo.tags || [],
            `name_${lng === 'jp' ? 'ja' : lng}`,
          );
          return Config.getTagDesByCharacter(tag, ',', lng);
        }
        return '';
      },
    };
  }

  generateImageLicenseJSONLD(options) {
    let { photo, t, lng } = this.props;
    if (!photo) {
      return '';
    }
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'ImageObject',
            contentUrl: photo.path,
            name: t(Config.getPrefixContent('title_download_page_seo'), {
              title: options.title,
              id: photo.id,
            }),
            caption: t(Config.getPrefixContent('title_download_page_seo'), {
              title: options.title,
              id: photo.id,
            }),
            description: t(
              Config.getPrefixContent('meta_description_download_page_seo'),
              { ...options, id: photo.id },
            ),
            license: `${Config.getSiteURL()}/terms`,
            acquireLicensePage: `${Config.renderDownloadPageByServiceAndLanguage(
              lng,
              `${photo.id}${options.slugTitle ? `/${options.slugTitle}` : ''}`,
            )}`,
            isAccessibleForFree: true,
            isFamilyFriendly: true,
            representativeOfPage: true,
          }),
        }}
      />
    );
  }

  render() {
    const { t, lng, photo } = this.props;
    if (!photo?.id) {
      return throw404();
    }

    const getParams = this.getMetaDataParams();
    const { id = [] } = photo;
    const title = getParams.title(lng);
    const titleSlug = getParams.titleSlug(lng);
    let canonical = getCanonical(
      `/${keyConfig.get('route_detail_page')}/${id}${
        titleSlug ? `/${titleSlug}` : ''
      }`,
      lng,
    );

    const options = {
      tags: getParams.tagsNameTitle(),
      total: 1242251,
      title: unescape(title),
      slugTitle: getParams.titleSlug(lng),
      tag: getParams.tagsName().split(',')[0],
    };

    console.log('optionsoptions', options);

    return (
      <Layout>
        <Head>
          {/* {!Config.isDesignAC() && (
            <link
              rel="preload"
              as="image"
              imagesrcset={`${photo.thumbnail} 600w, ${photo.path}`}
            />
          )} */}
          {!Config.isDesignAC() && (
            <link
              rel="preload"
              href={`${photo.thumbnail}`}
              as="image"
              media="(max-width: 599px)"
            />
          )}
          {!Config.isDesignAC() && (
            <link
              rel="preload"
              href={`${photo.path}`}
              as="image"
              media="(min-width: 600px)"
            />
          )}
          {process.browser ? (
            <title>
              {t(Config.getPrefixContent('title_download_page_seo'), {
                title: options.title,
                id: id,
              })}
            </title>
          ) : (
            <title
              dangerouslySetInnerHTML={{
                __html: t(Config.getPrefixContent('title_download_page_seo'), {
                  title: options.title,
                  id: id,
                }),
              }}
            />
          )}
          <meta
            key="keywords"
            name="keywords"
            content={t(
              Config.getPrefixContent('meta_keywords_download_page_seo'),
              {
                title: options.title,
                tags: getParams.tagsName(),
              },
            )}
          />
          {lng === 'en' && <meta property="og:locale" content={'en_US'} />}
          {lng !== 'en' && (
            <meta
              property="og:locale"
              content={lng + '_' + lng?.toUpperCase()}
            />
          )}
          <meta
            key="description"
            name="description"
            content={t(
              Config.getPrefixContent('meta_description_download_page_seo'),
              { ...options, id: photo.id },
            )}
          />
          <link rel="canonical" href={canonical} key="canonical" />
          <ChinaWrap
            chinaOnly={
              <meta property="fb:app_id" content={Config.facebookAppID} />
            }
          />
          {Config.supportedHrefLangs.map((lang, index) => {
            const hrefLang = lang;
            const urlLang = Config.supportedLanguages[index]
              ? Config.supportedLanguages[index]
              : 'en';
            const titleSlug = getParams.titleSlug(urlLang);

            if (hrefLang === 'zh-Hans' && urlLang === 'cn') {
              return (
                <link
                  key={hrefLang}
                  rel="alternate"
                  hrefLang={hrefLang}
                  href={`${Config.getSiteURL(null, 'cn')}/${keyConfig.get(
                    'route_detail_page',
                  )}/${id}${titleSlug ? `/${titleSlug}` : ''}`}
                />
              );
            } else if (hrefLang === 'ja') {
              if (Config.isDesignAC()) return null;

              let href = null;
              if (Config.isPhotoAC()) {
                // https://www.photo-ac.com/main/detail/4493988
                href = `https://www.photo-ac.com/main/detail/${id}`;
              } else if (Config.isIllustAC()) {
                // https://www.ac-illust.com/main/detail.php?id=1570779
                href = `https://www.ac-illust.com/main/detail.php?id=${id}`;
              } else if (Config.isSilhouetteAC()) {
                // https://www.silhouette-ac.com/detail.html?id=112856
                href = `https://www.silhouette-ac.com/detail.html?id=${id}`;
              }

              if (!href) return null;
              return (
                <link
                  key={hrefLang}
                  rel="alternate"
                  hrefLang={hrefLang}
                  href={href}
                />
              );
            } else {
              return (
                <link
                  key={hrefLang}
                  rel="alternate"
                  hrefLang={hrefLang}
                  href={`${Config.getSiteURL(
                    Config.serviceType,
                    Config.supportedLanguages[index],
                  )}/${keyConfig.get('route_detail_page')}/${id}${
                    titleSlug ? `/${titleSlug}` : ''
                  }`}
                />
              );
            }
          })}
          <meta
            property="og:title"
            content={t(Config.getPrefixContent('title_download_page_seo'), {
              title: options.title,
            })}
          />
          <meta property="og:type" content="article" />
          <meta property="og:image" content={photo.path} />
          {/* <meta
            property="og:image"
            content={`${
              Config.staticPrefix
            }/static/assets/image/logo/${Config.renderImagePage()}`}
          /> */}
          <meta
            property="og:description"
            content={t(
              Config.getPrefixContent('meta_description_download_page_seo'),
              {
                ...options,
                id: photo.id,
              },
            )}
          />
          <meta property="og:url" content={canonical} />
          <MetaTwitter
            url={canonical}
            title={t(Config.getPrefixContent('title_download_page_seo'), {
              title: options.title,
            })}
            description={t(
              Config.getPrefixContent('meta_description_download_page_seo'),
              {
                ...options,
                id: photo.id,
              },
            )}
            image={photo.path}
            site={`${Config.getSiteURL()}`}
            twitterUser={getParams.creator()}
          />
          {this.generateImageLicenseJSONLD(options)}
        </Head>
        <StripeProvider stripe={this.state.stripe}>
          {Config.isIllustAC() ? <IllustPage /> : <PhotoContainer />}
        </StripeProvider>
      </Layout>
    );
  }
}

// export const getServerSideProps = wrapper.getServerSideProps(
//   (store) => async (ctx) => {
//     const i18nProps = await serverSideTranslations(
//       ctx.locale || process.env.LANGUAGE,
//       ['common'],
//       nextI18nextConfig,
//     );

//     const {
//       token,
//       profile,
//       accountType,
//       isAuthenticated,
//       currentLanguage,
//       clientIp,
//       api,
//       sessionId,
//       ssoToken,
//       query,
//       req,
//       res,
//     } = await defaultPageServerSideContext({
//       ...ctx,
//       store,
//     });

//     const language = currentLanguage;

//     if (Config.isDesignAC()) {
//       const gotIt = Cookies.get('gotIt', req);
//       store.dispatch(
//         loadPhoto(
//           {
//             id: query.id,
//             gotIt,
//             language,
//             clientIp,
//           },
//           api,
//         ),
//       );
//     } else {
//       const gotIt = Cookies.get('gotIt', req);
//       store.dispatch(loadPhoto({ id: query.id, gotIt, language }, api));
//     }

//     // end the saga
//     store.dispatch(END);
//     await store.sagaTask.toPromise();

//     const photo = store.getState().photo.detail;
//     if (!photo?.id) {
//       res.statusCode = 404;
//     }

//     return {
//       props: {
//         ...i18nProps,
//         token,
//         profile,
//         accountType,
//         isAuthenticated,
//         currentLanguage,
//         sessionId,
//         ssoToken,
//         query,
//         isFromServer: !!req,
//       },
//     };
//   },
// );

export const getStaticPaths = async () => {
  const paths = [];

  return { paths, fallback: 'blocking' };
};

export const getStaticProps = wrapper.getStaticProps((store) => async (ctx) => {
  const i18nProps = await serverSideTranslations(
    ctx.locale || process.env.LANGUAGE,
    ['common'],
    nextI18nextConfig,
  );
  const { currentLanguage, api } = await defaultPageStaticContext({
    ...ctx,
    store,
  });
  if (Config.isDesignAC()) {
    store.dispatch(
      loadPhoto(
        { id: ctx.params.id, language: currentLanguage, clientIp: null },
        api,
      ),
    );
  } else {
    store.dispatch(
      loadPhoto({ id: ctx.params.id, language: currentLanguage }, api),
    );
    // store.dispatch(loadCommentsData({ data_id: ctx.params.id }));
  }

  // end the saga
  store.dispatch(END);
  await store.sagaTask.toPromise();

  const photo = store.getState().photo.detail;
  if (!photo?.id) {
    return {
      notFound: true,
    };
  } else {
    return {
      props: {
        ...i18nProps,
        currentLanguage,
        isFromServer: true,
      }, // will be passed to the page component as props
      revalidate: 60 * 60 * 24 * 7, // revalidate every 7 days
    };
  }
});

export default Photo;
